// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_edu-agent_edu-agent_module_ts":"c0bc48dab13c42dd","src_app_idscan_idscan-routing_module_ts":"4b3cdf147c98ad2e"}[chunkId] + ".js";
};